import React from "react";
import QuickAccessCard from "./QuickAccessCard";
import "./QuickAccess.css";

export default function QuickAccessRow({ cards = [] }) {
  return (
    <div>
    <div>            <h2 className="quick-title">Quick Access</h2>
</div>
    <div className="quick-access-row">
      {cards.map((card, idx) => (
        <QuickAccessCard key={idx} {...card} />
      ))}
    </div>
    </div>
  );
} 